import { StatusBadge } from "@components";
import type { EventBadgeVariant } from "../events/events.config";
import { getEventBadgePalette } from "./event-type-badge";

const RISK_HIGH_THRESHOLD = 70;
const RISK_MEDIUM_THRESHOLD = 30;

function getRiskVariant(riskPercentage: number): EventBadgeVariant {
	if (riskPercentage >= RISK_HIGH_THRESHOLD) {
		return "red";
	}
	if (riskPercentage >= RISK_MEDIUM_THRESHOLD) {
		return "amber";
	}
	return "green";
}

function getRiskLevelLabel(variant: EventBadgeVariant): string {
	if (variant === "red") {
		return "alto";
	}
	if (variant === "amber") {
		return "médio";
	}
	return "baixo";
}

export function RiskBadge({ riskPercentage }: { riskPercentage: number }) {
	const variant = getRiskVariant(riskPercentage);
	const roundedPercentage = Math.round(riskPercentage);

	return (
		<StatusBadge
			label={
				<>
					{roundedPercentage}%
					<span className="sr-only">{` (risco ${getRiskLevelLabel(variant)})`}</span>
				</>
			}
			palette={getEventBadgePalette(variant)}
		/>
	);
}
